import React from "react";
import { Text } from "@radix-ui/themes";
import { useParams, useSearchParams } from "react-router-dom";
import { FaceLivenessDetector } from "@aws-amplify/ui-react-liveness";
import "@aws-amplify/ui-react/styles.css";

const LivenessScan = () => {
  const { sessionId } = useParams();
  const [searchParams] = useSearchParams();
  const handler = searchParams.get("handler");

  const onAnalysisComplete = () => {
    if (window.flutter_inappwebview) {
      window.flutter_inappwebview.callHandler(
        handler,
        JSON.stringify({
          status: "success",
          data: {
            sessionId: sessionId,
          },
        })
      );
    }
  };

  const onError = (error) => {
    if (window.flutter_inappwebview) {
      window.flutter_inappwebview.callHandler(
        handler,
        JSON.stringify({
          status: "fail",
          errorCode: error.error.name,
          message: error.error.message,
        })
      );
    }
  };

  const onUserCancel = () => {
    if (window.flutter_inappwebview) {
      window.flutter_inappwebview.callHandler(
        handler,
        JSON.stringify({
          status: "fail",
          errorCode: "UserCancel",
          message: "User cancelled the liveness scan.",
        })
      );
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen">
      {!sessionId ? (
        <Text>Loading. Please wait.</Text>
      ) : (
        <FaceLivenessDetector
          disableStartScreen={true}
          sessionId={sessionId}
          region="ap-northeast-1"
          onAnalysisComplete={onAnalysisComplete}
          onError={onError}
          onUserCancel={onUserCancel}
        />
      )}
    </div>
  );
};

export default LivenessScan;
